import { ServiceHandler } from '../../../utils/api.utils';

export type UserPreferences = {
  defaultAgentId: string | null;
};

export const getUserPreferences = ServiceHandler<unknown, UserPreferences>({
  url: '/api/chat-agent/v1/user-preferences',
});

export const updateUserPreferences = ServiceHandler<
  { defaultAgentId: string | null },
  UserPreferences
>({
  url: '/api/chat-agent/v1/user-preferences',
  method: 'PUT',
});
